/**
 * Entry point for the opt-in syntax highlighting bundle.
 */
import { installSyntaxHighlighting } from '@openleaf-editor/plugins-highlight'

installSyntaxHighlighting()
